import React, { PropsWithChildren, useMemo, useState } from 'react';

import {
  CustomTableContext,
  CustomTableContextProps,
} from '@/components/table/context/CustomTable.context';
import { CustomTableStateModel } from '@/components/table/model/CustomTableState.model.ts';

interface Props<
  SORT_BY_COLUMN_NAME_MODEL extends string,
  SEARCH_FORM_MODEL extends object,
  ROW_ITEM_MODEL extends object,
> {
  customTableState: CustomTableStateModel<
    SORT_BY_COLUMN_NAME_MODEL,
    SEARCH_FORM_MODEL,
    ROW_ITEM_MODEL
  >;
}

// todo: add generic types for customTableState
export const CustomTableContextProvider: React.FC<
  PropsWithChildren<Props<string, object, object>>
> = ({ children, customTableState }) => {
  const [state, setState] = useState(customTableState);

  const context: CustomTableContextProps<string, object, object> = useMemo(() => {
    return {
      customTableState: state,
      setCustomTableState: setState,
    };
  }, [state]);

  return <CustomTableContext.Provider value={context}>{children}</CustomTableContext.Provider>;
};
